module.exports = __webpack_public_path__ + "static/media/Mask.075c1fcb.png";